import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import PersonProfileTable from './PersonProfileTable';

export default class JockeyProfileResultsPage extends Component {
  static propTypes = {
    profile: PropTypes.object
  };

  render() {
    const {
      profile = {},
      profile: {
        person_details: {
          name
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="hr-jockey-profile-results">
        <MetaDataWrapper title={`${name} - Jockey Profile`} />
        <PersonProfileTable profile={profile} rideLabel="Ride" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/JockeyProfileResultsPage.js